<template>
  <div class="bg-light">
    <div class="livraison-page container">
      <div v-if="cartsupp && cartsupp.items">
        <div class="bg-light">
          <div class="container section-header-breadcrumb">
            <div class="row">
              <div class="content text-left col-sm-12 col-md-12 col-lg-12">
                <h2 class="title-page">
                  <span class="back-link cursor-pointer" @click="BackToLivraison">
                    <i class="ti ti-back-left font-20 orange-color pe-2"></i>
                  </span>
                  Sélection du point relais
                </h2>
                <label class="breadcrumb-text">
                 <span class="pointer-cursor" @click.prevent="GoToDashboard" >Accueil</span> > <span class="pointer-cursor" @click.prevent="GoToStepCart" >Mon panier</span>  > <span class="cursor-pointer" @click="BackToLivraison"> Livraison > </span>
                  <span>Livraison en point relais</span>
                </label>
              </div>
            </div>
          </div>
          <div class="livraison-page container">
            <div class="content d-flex flex-column flex-lg-row gap-4 gap-lg-5 mb-4 cart-page-inner">
              <div class="col-12 col-lg-8 block-adresses">
                <!-- Même approche que les autres composants - cacher step-cart-centent sur mobile -->
                <div class="row step-cart ps-5 pe-5">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="d-flex gap-4 align-items-center py-4 step-cart-centent">
                      <div class="step-number" @click.prevent="GoToStepCart">
                        <span class="badge mx-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-100 h-75"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="#ec621a"
                            stroke-width="3"
                          >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" /></svg></span>
                        <span class="step-title">Votre panier</span>
                      </div>
                      <div class="separator"></div>
                      <div class="step-number">
                        <span class="badge badge-blue mx-2">2</span>
                        <span class="step-title">Livraison</span>
                      </div>
                      <div class="separator"></div>
                      <div class="step-number">
                        <span class="badge mx-2">3</span>
                        <span class="step-title">Paiement</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center" v-if="!isClient && ListAddressesFacturations">
                  <div class="col-12 col-lg-11 col-md-11 col-sm-11 d-flex justify-content-center justify-content-lg-start">
                    <img :src="iconlocation" class="shipping-icon" />
                    <label class="title-blue my-auto px-2 text-center text-lg-start">Mon adresse de facturation</label>
                  </div>
                </div>
                <div class="row justify-content-center liste-adresses" v-if="!isClient && ListAddressesFacturations">
                  <div class="col-12 col-lg-11 col-md-11 col-sm-11 my-2">
                    <form class="radio-group">
                      <div
                        class="radio-option"
                        :class="{ selected: true }"
                      >
                        <div class="location">
                          <div class="line1">
                            <img :src="user" />
                            <div class="radio-adresse">
                              {{ ListAddressesFacturations?.firstName }}
                              {{ ListAddressesFacturations?.lastName }}
                              <br />
                              {{ ListAddressesFacturations?.street }},
                              {{ ListAddressesFacturations?.postcode }}
                              {{ ListAddressesFacturations?.city }}
                            </div>
                          </div>
                          <div class="line2">
                            <div v-if="ListAddressesFacturations.cellphone" class="info-item">
                              <img :src="phone" />
                              <label>{{ ListAddressesFacturations.cellphone ?? "-" }}</label>
                            </div>
                            <div v-if="ListAddressesFacturations.email" class="info-item">
                              <img :src="envelope" />
                              <label>{{ ListAddressesFacturations.email ?? "-" }}</label>
                            </div>
                          </div>
                        </div>
                        <div class="custom-radio">
                          <input type="radio" :value="ListAddressesFacturations.id" v-model="selectedAddress" />
                          <img :src="checked" />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div >
                  <div class="row justify-content-center">
                    <div class="col-12 col-lg-11 col-md-11 col-sm-11 mb-2 d-flex justify-content-center justify-content-lg-start">
                      <img :src="iconlocation" class="shipping-icon" />
                       <label class="title-blue my-auto px-2 text-center text-lg-start" v-if="!isClient">Sélectionner le client destinataire</label>
                      <label class="title-blue my-auto px-2 text-center text-lg-start" v-else>Sélectionner un destinataire pour la réception en point relais</label>
                    </div>
                  </div>
                  
                  <div class="row justify-content-center liste-adresses">

                    <div class="col-12 col-lg-11 col-md-11 col-sm-11 my-2" >
                          <div class="search-block w-100" v-if="!isClient">
                            <form>
                              <input
                                type="text"
                                class="form-control"
                                v-model="searchAddress"
                                placeholder="Rechercher un client..."
                              />
                              <button class="search-btn">
                                <i class="ti ti-search"></i>
                              </button>
                            </form>
                          </div>
                          <div class="search-block w-100" v-else>
                            <form>
                              <input
                                type="text"
                                class="form-control"
                                v-model="searchAddress"
                                placeholder="Rechercher une adresse..."
                              />
                              <button class="search-btn">
                                <i class="ti ti-search"></i>
                              </button>
                            </form>
                          </div>
                    </div>
                    <div class="col-12 col-lg-11 col-md-11 col-sm-11 my-2">
                      <form class="radio-group" v-if="paginatedAddresses.length > 0">
                        <div
                          v-for="address in paginatedAddresses"
                          :key="address.id"
                          class="radio-option"
                          :class="{ selected: selectedAddress === address.id }"
                          @click="selectedAddress = address.id"
                        >
                          <div class="location">
                            <div class="line1">
                              <img :src="user" />
                              <div class="radio-adresse">
                                {{ address.firstName }} {{ address.lastName }}
                                <br />
                                {{ address.street }}, {{ address.postcode }} {{ address.city }}
                              </div>
                            </div>
                            <div class="line2">
                              <div v-if="address.cellphone" class="info-item">
                                <img :src="phone" />
                                <label>{{ address.cellphone ?? "-" }}</label>
                              </div>
                              <div v-if="address.email" class="info-item">
                                <img :src="envelope" />
                                <label>{{ address.email ?? "-" }}</label>
                              </div>
                            </div>
                          </div>
                          <div class="custom-radio">
                            <input type="radio" :value="address.id" v-model="selectedAddress" />
                            <img v-if="selectedAddress === address.id" :src="checked" />
                          </div>
                        </div>
                      </form>
                      <div v-else class="text-center p-4">
                        <p class="mb-0">
                          Vous n'avez pas encore d'adresse de livraison. Veuillez en ajouter une.
                        </p>
                      </div>
                      <div class="right-adress-item text-center text-lg-end mt-4">
                        <a href="#" class="btn btn-orange w-100 w-lg-auto" @click.prevent="OpenAddNewAdressModal">
                          <img :src="plus" class="icon-plus me-2" />
                          Ajouter une nouvelle adresse
                        </a>
                      </div>

                      <!-- Pagination -->
                    <div v-if="filteredAddresses.length > itemsPerPage" class="pagination mt-4 d-flex justify-content-center align-items-center">
                      <button @click="previousPage" :disabled="currentPage === 1" class="pagination-btn prev">
                          <i class="ti ti-angle-left"></i>
                        </button>
                      <div class="pagination-content">
                        <div class="pagination-btns mt-4">
                          <button
                           v-for="page in totalPages"
                              :key="page"
                              @click="goToPage(page)"
                            :class="['pagination-btn-numbers', 'mx-1', { active: currentPage === page }]"
                          >
                            {{ page }}
                          </button>
                        </div>
                        <span class="pagination-info">Sur {{ totalPages }}</span>
                      </div>

                      <button @click="nextPage" :disabled="currentPage === totalPages" class="pagination-btn next">
                          <i class="ti ti-angle-right"></i>
                        </button>
                    </div>
                    </div>
                  </div>
                  <div class="row justify-content-center sub-content">
                    <div class="col-12 col-lg-11 col-md-11 col-sm-11 my-2 text-center text-lg-start">
                      <p v-if="!isClient">
                        Vous souhaitez ajouter ou modifier une adresse de facturation ?
                        <router-link to="/contact" class="title-blue">Contactez-nous</router-link>
                      </p>
                      <p>
                        Vous souhaitez livrer à une autre adresse ?
                        <span class="title-blue cursor-pointer" @click.prevent="GoToLivraisonDomicile">
                          Veuillez sélectionner la livraison à domicile
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4 py-3 block-recap">
                 <label class="title-recap">Récapitulatif de la commande</label>
                 <div v-if="showWarehouseNotice" class="alert alert-info my-3">
                  <i class="ti ti-info-circle"></i>
                  <p>
                    <strong>Information :</strong> Suite à un arrêté préfectoral en lien avec l'épisode de froid en cours, les transporteurs ne sont pas autorisés à circuler dans la région de notre entrepôt logistique avant la fin de journée du 06 janvier, au plus tôt. Cela peut donc entrainer un léger retard dans la prise en charge de vos commandes par ces derniers.
                  </p>
                </div>
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center">
                  <label class="recap-text p-0">Prix des produits</label>
                  <span class="recap-text">{{ TotalCart }} € HT</span>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center"  v-if="showRemiseLine && remise">
                  <p class="col-6 col-lg-6 p-0">
                    <label class="recap-text">Remise</label>
                    <br />
                    <span class="text-slogan" v-if="couponCode"> {{ couponCode }} </span>
                    <span class="text-slogan" v-else>inclus dans le prix des produits</span>
                  </p>
                  <span class="recap-text">{{ remise }} €</span>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if='tvaTieCode==="0"'>
                  <label class="recap-text p-0">TVA</label>
                  <span class="recap-text">{{ Tva }} €</span>
                </div>
                <div class="my-3 my-md-4 row">
                  <p class="col-12 col-lg-10">
                    <label class="recap-text">Livraison</label>
                    <br />
                    <span class="text-slogan">Frais calculés à l'étape suivante</span>
                  </p>
                </div>
                <hr class="divider" />
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if='tvaTieCode==="0"'>
                  <label class="recap-text">Total TVA inclus</label>
                  <span class="recap-text-blue px-0">{{ TotalCartTTC }} € TTC</span>
                </div>
                 <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-else>
                  <label class="recap-text">Total</label>
                  <span class="recap-text-blue px-0">{{ TotalCartTTC }} € HT</span>
                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <button
                      class="btn text-white btn-check-order mt-2 w-100 w-lg-60"
                      :disabled="!selectedAddress || isSubmitting"
                      @click="ConfirmCommande()"
                    >
                      <span
                        v-if="isSubmitting"
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span>{{ isSubmitting ? "Confirmation en cours..." : "Confirmer" }}</span>
                    </button>
                  </div>
                  <div class="col-12 text-center mt-2">
                    <span class="text-slogan mt-3">Paiement 100% sécurisé avec technologies SSL et 3D Secure.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ADD ADDRESS MODAL -->
  <div
    class="modal fade"
    id="adressclient"
    ref="adressclient"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-width">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button type="button" class="close-link" data-bs-dismiss="modal" aria-label="Fermer">
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal">
          <h3>Ajout d'une nouvel adresse de livraison</h3>
          <form class="mt-4">
            <div class="d-flex flex-column flex-md-row gap-3">
              <div class="input-form flex-fill">
                <label class="label-control">Nom*</label>
                <input type="text" class="form-control" v-model="clientadress.lastName" />
                <span v-if="erroradressLastName" class="error-message mb-1">{{ erroradressLastName }}</span>
              </div>
              <div class="input-form flex-fill">
                <label class="label-control">Prénom*</label>
                <input type="text" class="form-control" v-model="clientadress.firstName" />
                <span v-if="erroradressFirstName" class="error-message mb-1">{{ erroradressFirstName }}</span>
              </div>
            </div>
            <div class="d-flex flex-column flex-md-row gap-3 mt-3">
              <div class="input-form flex-fill">
                <label class="label-control">Adresse*</label>
                <input type="text" class="form-control" v-model="clientadress.street" />
                <span v-if="erroradressStreet" class="error-message mb-1">{{ erroradressStreet }}</span>
              </div>
              <div class="input-form flex-fill">
                <label class="label-control">Code postal*</label>
                <input type="text" class="form-control" v-model="clientadress.postcode" v-only-digits />
                <span v-if="erroradressCodePostal" class="error-message mb-1">{{ erroradressCodePostal }}</span>
              </div>
            </div>

             <div class="d-flex flex-column flex-md-row gap-3 mt-3">
              <div class="input-form flex-fill">
                <label class="label-control">Email*</label>
                <input type="email" class="form-control" v-model="clientadress.email" />
                <span v-if="erroradressEmail" class="error-message mb-1">{{ erroradressEmail }}</span>
              </div>
              <div class="input-form flex-fill">
                <label class="label-control">Téléphone*</label>
                <input type="tel" class="form-control" v-model="clientadress.cellphone" v-only-digits />
                <span v-if="erroradressCellphone" class="error-message mb-1">{{ erroradressCellphone }}</span>
              </div>
              </div>
            <div class="d-flex flex-column flex-md-row gap-3 mt-3">
              <div class="input-form flex-fill">
                <label class="label-control">Ville*</label>
                <input type="text" class="form-control" v-model="clientadress.city" />
                <span v-if="erroradressVille" class="error-message mb-1">{{ erroradressVille }}</span>
              </div>
              <div class="input-form client-pays flex-fill">
                <label class="label-control">Pays*</label>
                <div class="dropdown w-100 mb-2">
                  <button
                    class="form-control dropdown-toggle w-100 text-start"
                    :class="{ error: erroradressPays }"
                    type="button"
                    @click="toggleDropdownCountry"
                  >
                    {{ selectedCountry.name || "Sélectionner un pays" }}
                  </button>
                  <div
                    class="dropdown-menu show w-100 p-2"
                    v-if="isOpenCountry"
                    style="max-height: 300px; overflow-y: auto"
                  >
                    <input
                      type="text"
                      class="form-control mb-2"
                      placeholder="Rechercher un pays..."
                      v-model="searchCountry"
                      @click.stop
                    />
                    <button
                      v-for="country in filteredCountries"
                      :key="country.code"
                      class="dropdown-item text-start"
                      @click="selectCountry(country)"
                    >
                      {{ country.name }}
                      <span v-if="selectedCountry.code === country.code" class="ms-2 text-success">✔</span>
                    </button>
                  </div>
                </div>
                <span v-if="erroradressPays" class="error-message mb-1">{{ erroradressPays }}</span>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-4">
              <button class="btn btn-orange w-100 w-md-auto" id="save-client-adress" @click.prevent="AddNewAdressClient">
                Enregistrer
              </button>
            </div>
            <div v-if="successadressMessage" class="alert alert-success mt-4 w-100 w-md-50 content-centered">
              <span class="success-message">{{ successadressMessage }}</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iconlocation from "@/assets/location.svg";
  import user from "@/assets/images/user.svg";
  import phone from "@/assets/images/phone.svg";
  import envelope from "@/assets/images/envelope.svg";
  import checked from "@/assets/images/check-box-orange.png";
  import plus from "@/assets/images/plus-circle.svg";
  import { useCartStore } from "@/stores/cartStore";
  import { useRegisterStore } from "@/stores/register";
  import { Modal } from "bootstrap";
  import { getCountries, CreateNewAdressClient } from "@/api/auth";
  import { updateOrder } from "@/api/orders";
  import { useCheckoutStore } from "@/stores/useCheckoutStore";
  import { useAddressesStore } from "@/stores/esupplyvet/addressesStore";
import { useDelegueStore } from '@/stores/delegueStore';
import { useShippingMethodesStore } from "@/stores/shippingMethodStore";
import { updateShipmentShippingMethod, getOrderDetails } from "@/api/orders";

  export default {
    name: "SelectionAdresseRelaisPage",
    data() {
      return {
        user,
        phone,
        envelope,
        checked,
        plus,
        cart: {
          items: [],
        },
        cartStore: null,
        registerStore: null,
        shippingMethodStore: null,
        iconlocation,
        selectedAddress: null, // Single address selection
        isSubmitting: false,
        clientadress: {
          firstName: "",
          lastName: "",
          street: "",
          postcode: "",
          city: "",
          countryCode: "",
          email: "",
          cellphone: "",
        },
        selectedCountry: {},
        isOpenCountry: false,
        searchCountry: "",
        countries: [],
        erroradressLastName: "",
        erroradressFirstName: "",
        erroradressStreet: "",
        erroradressCodePostal: "",
        erroradressVille: "",
        erroradressPays: "",
        canStoreClientadress: true,
        isLoadingClientadress: false,
        successadressMessage: "",
        searchAddress: "", // New data property for search input
        currentPage: 1, // Pagination: current page
        itemsPerPage: 4, // Pagination: items per page
        erroradressEmail: "",
        erroradressCellphone: "",
      };
    },
    computed: {
      filteredCountries() {
        const query = this.searchCountry.toLowerCase();
        return this.countries.filter(country => country.name.toLowerCase().includes(query));
      },
       filteredAddresses() {
        let data = this.ListAddressesDomicile;
        if (this.searchAddress !== "") {
          data = data.filter(
            addr =>
              (addr.firstName + " " + addr.lastName)?.toLowerCase().includes(this.searchAddress.toLowerCase()) ||
              addr.street?.toLowerCase().includes(this.searchAddress.toLowerCase()) ||
              addr.postcode?.toLowerCase().includes(this.searchAddress.toLowerCase()) ||
              addr.city?.toLowerCase().includes(this.searchAddress.toLowerCase())
          );
        }
        return data;
      },
      TotalCart() {
        let total = 0;
        const cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsSubtotal / 100;
        return this.formatPrice(total);
      },
      Tva() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = (cartStore.Cart.taxTotal - (cartStore.Cart.shippingTotal - cartStore.Cart.shippingTaxTotal) )/ 100;
        return this.formatPrice(total);
      },

      remise() {
        var total = 0;
        var cartStore = useCartStore();
        total = cartStore.Cart.orderPromotionTotal / 100;
        return total ? this.formatPrice(total) : 0;
      },
      couponCode() {
        const cartStore = useCartStore();
        return cartStore.Cart?.coupon_code || "";
      },

      tvaTieCode() {
        var cartStore = useCartStore();
        return cartStore.Cart.tvaTieCode
      },
      TotalCartTTC() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsTotal / 100;
        return this.formatPrice(total);
      },
      cartsupp() {
        const cartStore = useCartStore();
        return cartStore.Cart;
      },
     

      ListAddressesFacturations() {
         const cartStore = useCartStore();
        if (this.isDelegue && cartStore.Cart?.vetCustomer?.adressesFacturation) {
          // Delegate user - use vet customer's billing address
          console.log('Using delegate vet billing address from cart');
          return cartStore.Cart.vetCustomer.adressesFacturation;
        } else {
          // Regular user or client - use register store data
          console.log('Using regular vet billing address from register store');
          return this.registerStore.Veterinaire?.adressesFacturation;
        }
      },
      ListAddressesDomicile() {
        // Ensure it's an array or return an empty array to prevent errors
        return this.addressesStore.homeAddresses;
      },
       isClient() {
        // Assuming isClient is determined by some property in registerStore
       return this.registerStore.user?.role === "client";
      },
      loading() {
        return this.cartStore?.loading || false;
      },
      paginatedAddresses() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredAddresses.slice(start, end);
      },
      totalPages() {
        return Math.ceil(this.filteredAddresses.length / this.itemsPerPage);
      },

        isDelegue() {
        return this.registerStore.user?.role === "delegues";
      },

       userRole() {
        return this.registerStore.user?.role ;
      },

      selectedVetForDelegue() {
         const delegueStore = useDelegueStore();
        return delegueStore.selectedVeterinarian;
      },

       showWarehouseNotice() {
        const today = new Date();
        const deadline = new Date('2026-01-07T00:00:00');
        return today < deadline;
      },
      showRemiseLine() {
        const subtotal = this.cartsupp?.itemsSubtotal || 0;
        const remiseValue = Math.abs(this.cartsupp?.orderPromotionTotal || 0);
        return subtotal > 0 && remiseValue > 0 && remiseValue < subtotal;
      },
    },
    created() {
      this.registerStore = useRegisterStore();
      this.addressesStore = useAddressesStore();
      this.shippingMethodStore = useShippingMethodesStore();
      // Ensure shipping methods are loaded
      if (!this.shippingMethodStore.ShippingMethodes || this.shippingMethodStore.ShippingMethodes.length === 0) {
         // Assuming useDelegueStore is available or needed
          const delegueStore = useDelegueStore(); 
         this.shippingMethodStore.fetchShippingMethodes(this.registerStore.user?.role, delegueStore?.selectedVeterinarian?.id);
      }
      this.registerStore.fetchVeterinaire();
      this.addressesStore.fetchAddresses();
      this.GetPays();
    },
    methods: {
      formatPrice(value) {
        if (value == null || isNaN(value)) return '0,00';
        const num = Number(value);
        return num.toFixed(2).replace('.', ',');
      },
      async ConfirmCommande() {
        if (this.isSubmitting) return;

        try {
          const order = this.cartsupp;
          const tokenValue = order?.tokenValue;

          if (!tokenValue) {
            console.error("Aucun tokenValue pour la commande");
            return;
          }

          let selectedAddress;
          selectedAddress = this.ListAddressesDomicile.find(addr => addr.id === this.selectedAddress);

          if (!selectedAddress) {
            console.error("Adresse sélectionnée introuvable");
            return;
          }

          this.isSubmitting = true;

          let shippingAddressPayload = {
            firstName: selectedAddress.firstName,
            lastName: selectedAddress.lastName,
            street: selectedAddress.street,
            postcode: selectedAddress.postcode,
            city: selectedAddress.city,
            cellphone: selectedAddress.cellphone,
            email: selectedAddress.email,
            countryCode: selectedAddress.countryCode,
            adrcod: selectedAddress.adrcod || null, 
          };

          let billingAddressPayload;

          const defaultBillingAddress = this.ListAddressesFacturations;
          if (defaultBillingAddress && defaultBillingAddress.id) {
            billingAddressPayload = {
              firstName: defaultBillingAddress.firstName,
              lastName: defaultBillingAddress.lastName,
              street: defaultBillingAddress.street,
              postcode: defaultBillingAddress.postcode,
              city: defaultBillingAddress.city,
              cellphone: defaultBillingAddress.cellphone,
              email: defaultBillingAddress.email,
              countryCode: defaultBillingAddress.countryCode,
              adrcod: defaultBillingAddress.adrcod || null,
            };
          } else {
            // Fallback to shipping address if no billing address exists
            billingAddressPayload = shippingAddressPayload;
          }

          const couponCodePayload = order.coupon_code || "";
          const payload = {
            billingAddress: billingAddressPayload,
            shippingAddress: shippingAddressPayload,
          };

          if (couponCodePayload) {
            payload.couponCode = couponCodePayload;
          }

          console.log("Payload to update order:", payload);

          const checkoutStore = useCheckoutStore();
          const delegueStore = useDelegueStore();
          const registerStore = useRegisterStore();
          const vetId = delegueStore.getSelectedVeterinarian?.id;
          const userRole = registerStore.user?.role || "";
          const response = await updateOrder(tokenValue, payload, userRole === "delegues", vetId);
          checkoutStore.setOrder(response.data);
          this.$router.push({ name: "mode-paiement" });
        } catch (error) {
          console.error("Erreur lors de la confirmation de la commande :", error);
        } finally {
          this.isSubmitting = false;
        }
      },
      GoToStepCart() {
        this.$router.push({ name: "my-cart" });
      },
      BackToLivraison() {
        this.$router.push({ name: "livraison" });
      },
       GoToDashboard() {
        this.$router.push({ name: "dashboard-home" });
      },
      async GoToLivraisonDomicile() {
        try {
           const selectedMode = this.shippingMethodStore.ShippingMethodes.find(mode => mode.code === "OLD8ID");

          if (!selectedMode) {
             console.error("Mode de livraison domicile non trouvé.");
             this.$router.push({ name: "livraison-domicile" }); // Fallback navigation
             return;
          }

          const tokenValue = this.cartsupp.tokenValue;
          const order = await getOrderDetails(tokenValue);
          const shippingMethodIRI = `/api/v2/shop/shipping-methods/${selectedMode.code}`;
          const shipmentId = order.data.shipments?.[0]?.id;

           if (shipmentId) {
             await updateShipmentShippingMethod(tokenValue, shipmentId, shippingMethodIRI);
             const checkoutStore = useCheckoutStore();
             checkoutStore.setShippingMethod(selectedMode.code);
          }

        } catch (err) {
           console.error("Erreur lors de la mise à jour du mode de livraison:", err);
        }
        this.$router.push({ name: "livraison-domicile" });
      },
      OpenAddNewAdressModal() {
        this.ResetFormClientAdress();
        const modalElement = this.$refs.adressclient;
        const modalInstance = Modal.getOrCreateInstance(modalElement);
        modalInstance.show();
      },
      GetPays() {
        getCountries()
          .then(res => {
            this.countries = res.data;
          })
          .catch(() => {});
      },
      toggleDropdownCountry() {
        this.isOpenCountry = !this.isOpenCountry;
      },
      selectCountry(country) {
        this.selectedCountry = country;
        this.clientadress.countryCode = country.code;
        this.isOpenCountry = false;
        this.searchCountry = "";
      },
        AddNewAdressClient() {
        this.erroradressLastName = "";
        this.erroradressFirstName = "";
        this.erroradressStreet = "";
        this.erroradressCodePostal = "";
        this.erroradressVille = "";
        this.erroradressPays = "";
        this.canStoreClientadress = true;
        this.isLoadingClientadress = true;
        this.successadressMessage = "";
        this.erroradressEmail = "";
        this.erroradressCellphone = "";

        var spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Enregistrement en cours ...';
        document.getElementById("save-client-adress").innerHTML = spinner;

        this.CheckValidateClientAdress();
        if (this.canStoreClientadress) {
          this.clientadress.divalto_id = this.registerStore.Veterinaire.divalto_id;
          CreateNewAdressClient(this.clientadress, this.userRole , this.selectedVetForDelegue?.id)
            .then(res => {
              if (res.data && res.data.id) {
                this.ResetFormClientAdress();
                this.addressesStore.fetchAddresses(); // Refresh addresses
                this.successadressMessage = "Votre nouvelle adresse à été ajouté avec succès";
                setTimeout(() => {
                  this.successadressMessage = "";
                  const modalElement = this.$refs.adressclient;
                  const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
                  modalInstance.hide();
                }, 1000);
              }
              document.getElementById("save-client-adress").innerHTML = "Enregistrer";
              this.isLoadingClientadress = false;
            })
            .catch(() => {
              this.isLoadingClientadress = false;
              document.getElementById("save-client-adress").innerHTML = "Enregistrer";
            });
        }
      },
      CheckValidateClientAdress() {
        if (this.clientadress.lastName === "") {
          this.erroradressLastName = "Le champ nom est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.firstName === "") {
          this.erroradressFirstName = "Le champ prénom est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.street === "") {
          this.erroradressStreet = "Le champ adresse est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.postcode === "") {
          this.erroradressCodePostal = "Le champ code postal est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.city === "") {
          this.erroradressVille = "Le champ ville est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.countryCode === "") {
          this.erroradressPays = "Le champ pays est obligatoire";
          this.canStoreClientadress = false;
        }

        if (this.clientadress.email === "") {
          this.erroradressEmail = "Le champ email est obligatoire";
          this.canStoreClientadress = false;
        } else if (!this.isValidEmail(this.clientadress.email)) {
          this.erroradressEmail = "Veuillez entrer un email valide";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.cellphone === "") {
          this.erroradressCellphone = "Le champ téléphone est obligatoire";
          this.canStoreClientadress = false;
        } else if (!this.isValidPhoneNumber(this.clientadress.cellphone)) {
          this.erroradressCellphone = "Veuillez entrer un numéro de téléphone valide";
          this.canStoreClientadress = false;
        }
        if (!this.canStoreClientadress) {
          this.isLoadingClientadress = false;
          document.getElementById("save-client-adress").innerHTML = "Enregistrer";
        }
      },

       isValidEmail(email) {
        // Basic email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      },
      isValidPhoneNumber(cellphone) {
        // Basic phone number validation (allows numbers, spaces, dashes, and optional country code)
        const phoneRegex = /^\+?\d[\d\s-]{8,}$/;
        return phoneRegex.test(cellphone);
      },
      ResetFormClientAdress() {
        this.clientadress = {
          firstName: "",
          lastName: "",
          street: "",
          postcode: "",
          city: "",
          countryCode: "",
          email: "",
          cellphone: "",
        };
        this.selectedCountry = {};
        this.erroradressLastName = "";
        this.erroradressFirstName = "";
        this.erroradressStreet = "";
        this.erroradressCodePostal = "";
        this.erroradressVille = "";
        this.erroradressPays = "";
        this.canStoreClientadress = true;
        this.isLoadingClientadress = false;
        this.successadressMessage = "";
        this.erroradressEmail = "";
        this.erroradressCellphone = "";
      },
      previousPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          window.scrollTo({ top: 20, behavior: "smooth" });
        }
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          window.scrollTo({ top: 20, behavior: "smooth" });
        }
      },
      goToPage(page) {
        this.currentPage = page;
        window.scrollTo({ top: 20, behavior: "smooth" });
      },
    },
  };
</script>

<style scoped>
  .livraison-page {
    padding: 15px;
    text-align: center;
    background: #f5f6f9;
    min-height: 500px;
  }

  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    padding: 0 15px;
  }

  .section-header-breadcrumb .title-page {
    font-size: 30px;
    font-weight: bold;
    color: #1e347d;
  }

  .section-header-breadcrumb .breadcrumb-text {
    font-size: 15px;
    font-weight: normal;
  }

  .section-header-breadcrumb .breadcrumb-text span {
    color: #1e347d;
  }

  .step-cart {
    justify-content: center;
    margin-bottom: 3rem;
  }

  .title-blue {
    color: #1e347d;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .step-cart-centent {
    justify-content: center;
    border: 1px solid #aeb1ba;
    border-radius: 10px;
  }

  .badge-blue {
    background-color: #1e347d !important;
    color: white !important;
    border-radius: 50%;
    font-size: 1.5rem;
  }

  .badge {
    background-color: #eee;
    color: #ec621a;
    border-radius: 50%;
    font-size: 1.5rem;
  }

  .step-cart .step-title {
    color: #000;
    font-weight: bold;
    font-size: 18px;
    opacity: 0.7;
  }

  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .radio-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 2px solid #aeb1ba;
    padding: 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: border-color 0.3s;
  }

  .radio-option:hover,
  .radio-option.selected {
    background: #f5f6f9 0% 0% no-repeat padding-box;
    border: 2px solid #1e347d;
  }

  .location {
    flex: 1;
  }

  .radio-adresse {
    text-align: justify;
    font-family: "DM Sans", sans-serif !important;
  }

  .line1 {
    display: flex;
    align-items: center;
    color: #363739;
    font-size: 15px;
    margin-bottom: 8px;
    gap: 8px;
  }

  .line2 {
    display: flex;
    color: #363739;
    font-size: 15px;
    gap: 16px;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
  }

  .custom-radio {
    position: relative;
    padding-left: 24px;
    display: flex;
    align-items: center;
  }

  .custom-radio input[type="radio"] {
    opacity: 0;
    position: absolute;
    right: 0;
    height: 0;
    width: 0;
  }

  .block-recap {
    background: white;
    text-align: left;
    padding: 30px;
    max-height: max-content;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.1);
  }

  .block-recap .title-recap {
    color: #1e347d;
    font-size: 20px;
    font-weight: bold;
  }

  .block-recap .recap-text {
    font-size: 20px;
  }

  .block-recap .recap-text-blue {
    font-size: 20px;
    color: #1e347d;
    font-weight: bold;
  }

  .block-recap .text-slogan {
    font-size: 12px;
    color: #1e347d;
    font-style: italic;
  }

  .block-recap .divider {
    width: 90%;
    position: relative;
    left: 5%;
  }

  @media (max-width: 768px) {
    .livraison-page {
      padding: 15px;
    }
  }

  .error,
  .empty {
    color: #777;
    font-size: 1.2em;
  }

  .error {
    color: red;
    font-weight: bold;
  }

  .empty {
    color: #888;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 1.2rem;
  }

  .spinner {
    border: 4px solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .modal-width {
    max-width: 600px;
  }

  .padd-modal {
    padding: 20px 40px;
  }

  .close-link {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #6c757d;
  }

  .error-message {
    color: red;
    font-size: 0.8rem;
  }

  .success-message {
    color: green;
    font-size: 0.9rem;
  }

  .content-centered {
    margin: 0 auto;
  }

  /* Responsive Styles pour mobiles uniquement - Même approche que les autres composants */
  @media (max-width: 768px) {
    /* Cacher step-cart-centent exactement comme dans les autres composants */
    .step-cart-centent {
      display: none !important;
    }

    .livraison-page {
      padding: 10px;
    }

    .section-header-breadcrumb {
      padding: 0 10px;
      text-align: center;
    }

    .section-header-breadcrumb .title-page {
      font-size: 24px;
      text-align: center;
    }

    .section-header-breadcrumb .breadcrumb-text {
      font-size: 14px;
      text-align: center;
    }

    .content.cart-page-inner {
      gap: 20px !important;
    }

    .block-adresses {
      margin-bottom: 1rem;
    }

    .step-cart {
      margin-bottom: 1.5rem;
    }

    .title-blue {
      font-size: 16px;
    }

    .shipping-icon {
      width: 20px;
      height: 20px;
    }

    .radio-option {
      padding: 12px;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    .custom-radio {
      align-self: flex-end;
      padding-left: 0;
    }

    .line1 {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .line2 {
      flex-direction: column;
      gap: 8px;
    }

    .radio-adresse {
      font-size: 14px;
    }

    .block-recap {
      padding: 20px;
    }

    .block-recap .title-recap {
      font-size: 18px;
      text-align: center;
      display: block;
      width: 100%;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 16px;
    }

    .btn-check-order {
      width: 100%;
      padding: 12px;
    }

    .btn-orange {
      width: 100%;
    }

    .back-link {
      display: inline-block;
      margin-bottom: 0.5rem;
    }

    .separator {
      display: none;
    }

    .padd-modal {
      padding: 15px 20px;
    }

    .modal-width {
      max-width: 95%;
      margin: 0 auto;
    }

    .pagination {
      gap: 10px;
    }

    .pagination-content {
      text-align: center;
    }

    .pagination-btns {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }

  @media (max-width: 576px) {
    .section-header-breadcrumb .title-page {
      font-size: 20px;
    }

    .breadcrumb-text {
      font-size: 13px !important;
    }

    .title-blue {
      font-size: 15px;
    }

    .radio-option {
      padding: 10px;
    }

    .block-recap {
      padding: 15px;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 15px;
    }

    .radio-adresse {
      font-size: 13px;
    }

    .line1,
    .line2 {
      font-size: 14px;
    }

    .padd-modal {
      padding: 10px 15px;
    }
  }

  /* Pour les très petits écrans */
  @media (max-width: 360px) {
    .section-header-breadcrumb .title-page {
      font-size: 18px;
    }

    .breadcrumb-text {
      font-size: 12px !important;
    }

    .radio-option {
      padding: 8px;
    }

    .block-recap {
      padding: 12px;
    }

    .pagination-btn-numbers {
      padding: 5px 10px;
      font-size: 12px;
    }
  }
</style>